export function dateFormatter(date: Date | null | string | undefined): string {
  if (!date) return "";

  const dateObj = new Date(date);

  const year = dateObj.getUTCFullYear();
  const month = dateObj.getUTCMonth();
  const day = dateObj.getUTCDate();

  const localDate = new Date(Date.UTC(year, month, day));

  const formatter = Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
    year: "numeric",
  });

  return formatter.format(localDate);
}
